function Loader(){
    return (
        <div className="container-fluid text-center p-5">
            <div className="spinner-border text-dark" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
}

export default Loader;